module.exports = __webpack_public_path__ + "img/fa-regular-400.a7fe14be.svg";